import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Eye } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { MeetingRoom, SA_LOGO } from "@/components/meeting/MeetingRoom";
import { usePageMeta } from "@/lib/seo";

export default function WatchMeetPage() {
  const { code } = useParams();
  usePageMeta("Watch meeting");
  const [conf, setConf] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [body, setBody] = useState(null);
  const [n, setN] = useState(0);
  useEffect(() => { api.get(`/api/rtc/view/${code}`).then(r => setConf(r.data)).catch(e => setErr(e.response?.data?.detail || "That viewer link isn't valid")); }, [code]);
  useEffect(() => { if (conf && new URLSearchParams(window.location.search).get("tv") === "1") setBody({ name: `TV screen ${Math.floor(Math.random() * 90 + 10)}`, view_code: code }); }, [conf, code]);

  if (body) return <MeetingRoom key={n} confId={conf.id} joinBody={body} onPromote={(promo) => { setBody({ promo }); setN(x => x + 1); }} onLeave={() => window.location.reload()} />;
  const go = () => name.trim() && setBody({ name: name.trim(), view_code: code });
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="watch-meet-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 sm:p-8 space-y-5">
        <img src={SA_LOGO} alt="The ShopAdvisor" className="h-14 mx-auto" />
        {err ? <p className="text-center text-red-600" data-testid="watch-meet-error">{err}</p> : !conf ? <Loader2 className="w-6 h-6 animate-spin mx-auto text-slate-400" /> : (<>
          <div className="text-center">
            <p className="text-xs uppercase tracking-wider text-slate-400">You're invited to watch</p>
            <h1 className="text-2xl font-bold text-slate-900" data-testid="watch-meet-title">{conf.title}</h1>
            <p className="text-sm text-slate-500">Hosted by {conf.host_name}{conf.status !== "active" ? " · waiting for the host to start" : ""}</p>
          </div>
          <Input value={name} onChange={e => setName(e.target.value)} onKeyDown={e => e.key === "Enter" && go()} placeholder="Your name (shown in chat)" data-testid="watch-meet-name" />
          <button onClick={go} disabled={!name.trim()} className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50" data-testid="watch-meet-join"><Eye className="w-5 h-5" />Watch meeting</button>
          <p className="text-xs text-slate-400 text-center">No camera or mic needed — you can watch, chat, and raise your hand if you'd like to join on camera.</p>
        </>)}
      </div>
    </div>
  );
}
